import m from "mithril";

import state from "../../state";
import db    from "../../state/db";

import css from "./index.mcss";

import logo from "../icons/lyrite-logo2.svg?raw";
import list from "./list";
import importSongs from "./importSongs";

export default {
    oninit : (vnode) => {
        vnode.state.timestamp    = db.timestamp();
        vnode.state.defaultSongs = db.get("songs?default=true");
        vnode.state.customSongs  = db.get("songs?default=undefined");
    },
    onbeforeupdate : (vnode) => {
        if (vnode.state.timestamp !== db.timestamp()) {
            vnode.state.timestamp    = db.timestamp();
            vnode.state.defaultSongs = db.get("songs?default=true");
            vnode.state.customSongs  = db.get("songs?default=undefined");

            return true;
        }
    },
    view : (vnode) => [
        m("div", { class : css.home },

            m("div", { class : css.logoAndType },
                m.trust(logo),

                m("div", { class : css.logoType },
                    m("h1", { class : css.title },
                        state.appName,
                        m("span", { class : css.v1 }, " v1")
                    ),
                    m("h2", { class : css.subTitle }, state.tagline)
                )
            ),

            m("div", { class : css.center },
                m("div", { class : css.dash },
                    m("textarea", {
                        class       : vnode.state.focused ? css.textareaFocused : css.textarea,
                        value       : vnode.state.lyricString,
                        placeholder : vnode.state.hidePlaceholder ? "" : "paste or drop lyrics",
                        onfocus() {
                            vnode.state.focused         = true;
                            vnode.state.hidePlaceholder = true;
                        },
                        onblur() {
                            vnode.state.hidePlaceholder = false;
                        },
                        oninput(e) {
                            vnode.state.lyricString = e.target.value;
                            vnode.state.loadable    = e.target.value.length;
                        }
                    })
                ),

                vnode.state.loadable ?
                    m("div", { class : css.btnWrap },
                        m("button", {
                            class : css.loadBtn,
                            onclick() {
                                let slug = state.action("IMPORT SONG LYRICS", {
                                    lyricString : vnode.state.lyricString,
                                    userSong    : true
                                });

                                delete vnode.state.textarea;
                                delete vnode.state.load;

                                return m.route.set(slug);
                            }
                        }, "load song")
                    ) :
                    null
            ),

            // import from json
            m(importSongs),

            // loaded songs list
            Object.keys(vnode.state.customSongs).length ?
                m(list, { songs : vnode.state.customSongs, header : "your songs", clear : true }) :
                null,

            // loaded songs list
            Object.keys(vnode.state.defaultSongs).length ?
                m(list, { songs : vnode.state.defaultSongs, header : "default songs" }) :
                null
        )
    ]
};
